import { useController, useFormContext } from 'react-hook-form';
import {
  FieldWrapper,
  Label,
  TreeViewCombobox,
  Typography,
} from '@ghq-abi/design-system-v2';

interface TreeViewComboBoxHookFormProps
  extends React.ComponentPropsWithoutRef<typeof TreeViewCombobox> {
  name: string;
  label: string;
  emptyMessage?: string;
  searchPlaceholder?: string;
}
export function TreeViewComboBoxHookForm({
  name,
  label,
  emptyMessage,
  searchPlaceholder,
  ...props
}: Readonly<TreeViewComboBoxHookFormProps>) {
  const { control, formState } = useFormContext();
  const { field } = useController({
    control,
    name,
  });

  const hasError = !!formState.errors[name];

  return (
    <div className="space-y-2">
      <Label htmlFor={name}>
        <Typography variant="metadata-sm-regular" color="light">
          {label}
        </Typography>
      </Label>
      <FieldWrapper type={hasError ? 'error' : undefined}>
        <TreeViewCombobox
          id={field.name}
          ref={field.ref}
          value={field.value}
          disabled={field.disabled}
          onValueChange={field.onChange}
          emptyMessage={emptyMessage}
          searchPlaceholder={searchPlaceholder}
          className="bg-background-light [&_span]:!text-sm h-10"
          {...props}
        />
      </FieldWrapper>
    </div>
  );
}
